import React from 'react';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { AiOutlineFileExcel } from "react-icons/ai";

const ExportToExcel = ({ data, filename, date, activityName }) => {
  const handleExport = () => {
    if (!data || data.length === 0) {
      alert("No hay datos para exportar");
      return;
    }
    let orderedData;

    orderedData = data.map(({ email, name, lastName, present }) => ({
      Nombre: name,
      Apellido: lastName,
      Email: email,
      Asistencia: present ? "Presente" : "Ausente",
    }));

    // Crear la hoja de datos
    const dataSheet = XLSX.utils.json_to_sheet(orderedData, { origin: "A5" }); // empieza en A3 para dejar espacio al título

    // Insertar títulos
    dataSheet['A1'] = { t: 's', v: `Reporte de Asistencia`};
    dataSheet['A2'] = { t: 's', v: `Actividad: ${activityName}`};
    dataSheet['A3'] = { t: 's', v: `Fecha: ${date}`};

    // Combinar celdas
    dataSheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 3 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 3 } },
    ];

    // Crear el libro y exportar
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, dataSheet, "Datos");


    /*     const worksheet = XLSX.utils.json_to_sheet(orderedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Datos"); */

    XLSX.writeFile(workbook, filename);
  };

  return (
    <Button onClick={handleExport} className={`primaryBtn d-flex align-items-center`}>
      <AiOutlineFileExcel />Exportar a Excel
    </Button>
  );
}

export default ExportToExcel;